export enum EAccountTabs {
  PROFILE = 'profile',
  SETTINGS = 'settings',
  BILLING = 'billing',
}

export interface IMenuItems {
  name: string;
  link: string;
  icon?: string;
}

export enum EReplenishmentTypes {
  CARD = 'card',
  BANK = 'bank',
}

export interface ICardFormData {
  number: number | string;
  name: string;
  date: string;
  cvc: number | string;
  zip: number | string;
}

export interface IBankFormData {
  company_name: string;
  address: string;
  country: string;
  zip: number | string;
  ssn: number | string;
}
